export const CONFIG_NAMESPACE = 'vocento.config.multimedia.videoplayer';
export const LANGUAGE         = (document.documentElement.lang && document.documentElement.lang.split('-').shift()) || 'es';
export const LAZYLOAD_CLASS   = 'lazy';
export const EmbedStates = Object.freeze({
  EMPTY:       0b00,
  WITH_POSTER: 0b01,
  WITH_PLAYER: 0b10
});
export const VOCUSER_READY_PROMISE = 'vocuser:ready';
export const MODAL_LAYER_ID = 'voc-video-player-modalcontainer';
export const VIDEOPLAYER_REFRESH_EVENT = 'videoplayer:refresh';
export const MODAL_LAYER_PAYWALL_CONTENT_EVENT = 'paywall:content';
export const MODAL_LAYER_TAG_MANAGER_SET_EVENT = 'vtm:set';
export const MODAL_LAYER_BOOTSTRAP_OPTIONS = Object.freeze({
  backdrop: true,
  keyboard: true,
  show: true
});
export const DEFAULTS = {
  autoplay:    false,
  controls:    true,
  loop:        false,
  modallayer:  false,
  muted:       false,
  playsinline: true,
  videoad:     true,
  videolive:   false
};
export const SOURCES = Object.freeze({
  BRIGHTCOVE:  'brightcove',
  YOUTUBE:     'youtube',
  VIMEO:       'vimeo',
  DAILYMOTION: 'dailymotion',
  UNKNOWN:     'unknown'
});
export const DEFAULT_USERTYPE = 'anonimo';
export const USERTYPE_AD = Object.freeze({
  anonimo:    true,
  registrado: true,
  trial:      false,
  suscriptor: false
});



// WEBPACK FOOTER //
// ./src/constants.js